import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    text: String,
  }

  connect() {
    this.element.addEventListener('click', this.disabledOnClick.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('click', this.disabledOnClick.bind(this))
  }

  disabledOnClick() {
    this.element.classList.add('is-loading')
    this.element.setAttribute('aria-disabled', true)
    this.element.innerHTML = this.textValue
  }
}
